import { ApolloClient, from, HttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import { getValidAccessToken } from '@/core/auth/auth';

const graphqlUri =
  import.meta.env.VITE_GRAPHQL_URI ?? 'http://localhost:3010/graphql';

const authLink = setContext(async (_, prev) => {
  const token = await getValidAccessToken();
  return {
    headers: {
      ...prev.headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
});

const httpLink = new HttpLink({ uri: graphqlUri });

export const client = new ApolloClient({
  link: from([authLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: { fetchPolicy: 'network-only' },
    query: { fetchPolicy: 'network-only' },
  },
});
